import { render, staticRenderFns } from "./ConfimOrderVIew.vue?vue&type=template&id=72b08c03&scoped=true"
import script from "./ConfimOrderVIew.vue?vue&type=script&lang=js"
export * from "./ConfimOrderVIew.vue?vue&type=script&lang=js"
import style0 from "./ConfimOrderVIew.vue?vue&type=style&index=0&id=72b08c03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_c6nu2kfme4k2fztecbunkha7um/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b08c03",
  null
  
)

export default component.exports